import { EEntityType } from 'shared/repositories/favorites/entities/add_favorite/AddFavoriteEntityPublicRequestSchema';
import { EOfferType } from 'shared/types/offers';

export const MAP_OFFER_TYPE_TO_ENTITY_TYPE: {
  [index: string]: string;
} = {
  commercial: 'offerCommercial',
  newobject: 'newbuilding',
  flat: 'offerResidental',
  suburban: 'offerSuburban',
};

export const getEntityType = (offerType?: EOfferType): EEntityType => {
  return (MAP_OFFER_TYPE_TO_ENTITY_TYPE[offerType as string] as EEntityType) || EEntityType.OfferResidental;
};
